(function (angular) {
    angular
        .module('one.admin.config', [
            'one.admin.http',
            'one.admin.dependencies',
        ])
        .constant('config', {});
})(angular);
